<template>
  <div class="after">
    <Item
      v-for="item in nutrients"
      v-if="typeof data[item.key + '_Val'] !== 'undefined' && !['N', 'B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo'].includes(item.key)"
      :data="data"
      :item="item"
      :name="item.key + '_Val'"
    />
  </div>
</template>

<script>
import Item from './item';

export default {
  props: {
    data: Object
  },
  data () {
    return {
      nutrients: this.$store.getters['nutrients/data']
    }
  },
  components: {
    Item
  },
}
</script>

<style lang="scss" scoped>
  .after {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 110px;
      margin: 15px;

      span > div {
        padding: 1px;
      }

      // &:last-child {
      //   width: auto;
      //   flex-grow: 10;
      // }
    }

    .weight {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: #4C5056;
    }
    @media (max-width: 768px) {
      justify-content: space-between;
      > div {
        width: calc(50% - 8px);
        margin: 0 0 32px 0;
        &:last-child {
          width: calc(50% - 8px);
          flex-grow: unset;
        }
      }
    }
  }
</style>
